define([
	"dojo/_base/declare",
	"csi/def",
	"csi/def/Tab",
	"csi/def/View",
	"csi/util"
], function(declare, csi_def, Tab, View, util) {

	return declare(View, {
		// String - view id to insert above tabs
		idHeaderView: null,

		// Tab[] - array of tabs to display
		tabs: null,

		constructor: function(def) {
			this.idHeaderView = util.getProperty(def, "Header");
			this.tabs = util.getDefs(def, "ViewRef", Tab);

			// other than these two properties, only other property supported from base class is m_depPaths
		},

		resolve: function(/*csi.reflection.Class*/rcRoot, /*Node*/nodeRoot, /*Boolean*/bConfigure) {
			// summary: resolve view resources - base class will take care of headings
			var lmap = this.inherited(arguments);
			csi_def.resolveDefs(this.tabs, lmap, rcRoot, nodeRoot);
			return lmap;
		}
	});
});